import script from "./RenderResources.vue?vue&type=script&lang=ts"
export * from "./RenderResources.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__